<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import { useHead } from '@vueuse/head';
import { useFavoritesStore } from '@/stores/favorites';
import { storeToRefs } from 'pinia';
import messages from '@/locales/category/messages'
import BlackFriday from '@/components/BlackFriday.vue';
import ChristmasPromo from '@/components/ChristmasPromo.vue';


const { locale } = useI18n({
    useScope: 'global',
    messages
})

const { favorites } = storeToRefs(useFavoritesStore())
const router = useRouter()
const cat = ref(null);
const loaded = ref(true);
// we watch locale if it changes we reload the category
watch(locale, ()=>{
    //loaded.value = false
    //load_category()
})
// we watch the props.path if it changes we reload the category
function load_category(){
    loaded.value = false
    loadSales(locale.value).then((res)=>{
        cat.value = res
        setMeta()
        // we go back to top
        window.scrollTo(0, 0)
        loaded.value = true
    }).catch((err)=>{
        console.log(err)
        //router.push({name: '404'})
    })
}

function setMeta(){
    useHead({
        title: cat.value.meta.title,
        meta: [
            {
                name: 'description',
                content: cat.value.meta.description
            },
            {
                name: 'keywords',
                content: cat.value.meta.keywords
            }
        ]
    })
}

onMounted(()=>{
    //load_category()
})

</script>
<template>
    <BlackFriday variant="compact" />
    <ChristmasPromo variant="compact" />
    <template v-if="!loaded">
    <v-skeleton-loader 
            type="image"
            max-width="100%"
            :loading="!loaded"
            >
            
        </v-skeleton-loader>
        <v-skeleton-loader
            class="mx-auto mt-4"
            type="card"
            :loading="!loaded"
            max-width="400">
       
        </v-skeleton-loader>
    </template>
    <template v-else>
        <div id="category_header">
            <img src="/img/category/promo_bkg.jpg" :alt="'Favorites'" />
            <h1>{{ $t('category.favorites_title') }}</h1>
            <h2>{{ $t('category.favorites_subtitle') }}</h2>
        </div>
        <div class="content my-8">
            <div class="d-flex flex-wrap ga-4 justify-space-around w-100 flex-container">
                <ProductPreview v-for="prod in favorites" :key="prod" :id="prod" />
            </div>
        </div>

    </template>
</template>
<style lang="scss" scoped>
.flex-container{
    &:after, &:before{
        position: relative;
        content: '';
        height: 1px;
        width: 308px;
        visibility: hidden;

        order: 1000;
    }
}
#category_header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 190px;
    width: 100%;
    overflow: hidden;
    img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }
    h1{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 30px;
        font-weight: 700;
        line-height: 36.57px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
    h2{
        position: relative;
        z-index: 2;
        padding-left: 1rem;
        color: white;
        text-align: left;
        max-width: 997px;
        color: #FFF;
        width: 100%;
        font-family: Montserrat;
        font-size: 20px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;

    }
}
.content{
    max-width: 1024px;
    margin: 0 auto;
}
@media only screen and (min-width : $responsive-point) {
    .content{
        //justify-content: flex-start;
    }
    #category_header{
        height: 340px;
        h1{
            font-size: 50px;
            line-height: 60.83px;
        }
        h2{
            font-size: 30px;
            line-height: 36.57px;
        }
    }
}

</style>

<route lang="yaml">
name: category_favorites
props: true
meta:
    title: Favorites Kase
    layout: default
    middleware: guest
</route>